import domesticCNViewControls from './domesticCN';
import crmCNViewControls from './crmCN';
import retailTripsViewControls from './retailTrips';
import retailUpCountryCN from './retailUpCountryCN';
import retailPlanningCN from './retailPlanningCN';
import retailTripsPrimary from './retailTripsPrimary';
import retailTripsSecondary from './retailTripsSecondary';
import ondemandViewControls from './ondemand';
import summaryMetricsViewControls from './summaryMetricsCN';
import retailStoreCN from './retailStoreCN';
import supportPortalViewControls from './supportPortalCN';
import thirdPartyViewControls from './thirdPartyCN';
import { ValletTransactionsViewControls } from 'src/components/pages/ValletTransactions/utils';
import { FinanceUploadRequestsViewControls } from 'src/components/pages/FinanceUploadRequests/utils';
import tmsVehicleControls from './tmsVehicleControls';
import tmsVehicleAttendanceControls from './tmsVehicleAttendanceControls';
import tmsISTControls from './tmsISTControls';
import tmsBagControls from './tmsBagControls';
import tmsSetupRouteControls from './tmsSetupRouteControls';
import tmsSetupConnectionControls from './tmsSetupConnectionControls';
import tmsSetupExceptionControls from './tmsSetupExceptionControls';
import tmsSetupBaggingControls from './tmsSetupBaggingControls';
import setupBookingMastersControls from './setupBookingMastersControls';
import setupAllocationMasters from './setupAllocationMasters';
import setupRoutingControls from './setupRoutingControls';
import shelfControls from './shelfControls';
import crateControls from './crateControls';
import logisticsExpressCN from './logisticsExpressCN';
import consolidatedPlanningCN from './consolidatedPlanningCN';
import tmsSetupGateControls from './tmsSetupGateControls';
import tmsSetupDockControls from './tmsSetupDockControls';
import riderReconControls from './riderReconControls';
import approvalRequestsControls from './approvalRequestsControls';
import codSettlementControls from './codSettlementControls';
import ManifestDeclarationCN from './ManifestDeclarationCN';
import callsOverview from './callsOverview';
import myCalls from './myCalls';
import tmsSetupVehicleDocumentsControls from './tmsSetupVehicleDocumentsControls';
import reasonCategoryMasterControls from './reasonCategoryMasterControls';
import resequencingReasonMasterControls from './resequencingReasonMasterControls';
import addAdhocChargesControls from './addAdhocChargesControls';
import ltlNDRMasterControls from './ltlNDRMasterControls';
import packagingTypeMasterControls from './packagingTypeMasterControls';
import partialDeliveryReasonControls from './partialDeliveryReasonControls';
import lateDeliveryReasonControls from './lateDeliveryReasonControls';
import CarrierChangeReasonMasterData from './CarrierChangeReasonMasterControls';
import setupCarrierMastersRevamp from './setupCarrierMastersRevamp';
import serviceTaskMappingControls from './serviceTaskMappingControls';
import tmsEwbThresholdMasterControls from './tmsEwbThresholdMasterControls';
import tripContractsMasterControls from './tripContractsMasterControls';
import appUserApprovalControls from './appUserApprovalControls';
import vehicleApprovalControls from './vehicleApprovalControls';
import currencyConversionControls from './currencyConversionControls';
import supplyRequestControls from './supplyRequestControls';
import addressRegisterControls from './addressRegisterControls';
import customerManageControls from './customerManageControls';
import supplementaryServicesControls from './supplementaryServicesControls';
import itemUnitMasterControls from './itemUnitMasterControls';
import vehicleCompartmentMasterControls from './vehicleCompartmentMasterControls';
import flmRouteMasterControls from './flmRouteMasterControls';
import tripMapEditControls from './tripMapEditControls';
import { MAP_EDIT_VIEW_TYPE } from 'src/components/pages/retail/trip/TripManagerMapEdit/TripManagerMapEditKeys';
import {
  registerViewControl,
  getViewControl,
  getViewBuckets,
  getViewBucketColor,
  getDefaultSubBuckets,
  enhanceGeolocationFeatureBuckets,
} from './viewControlRegistry';

registerViewControl('retailTripsPrimary', retailTripsPrimary);
registerViewControl('retailTripsSecondary', retailTripsSecondary);
registerViewControl('crm', crmCNViewControls);
registerViewControl('logistics', crmCNViewControls);
registerViewControl('retailPlanning', retailPlanningCN);
registerViewControl('retailUpcountry', retailUpCountryCN);
registerViewControl('retailStore', retailStoreCN);
registerViewControl('domestic', domesticCNViewControls);
registerViewControl('retailTrips', retailTripsViewControls);
registerViewControl('ondemand', ondemandViewControls);
registerViewControl('on_demand_cod', codSettlementControls);
registerViewControl('metrics', summaryMetricsViewControls);
registerViewControl('supportPortal', supportPortalViewControls);
registerViewControl('thirdParty', thirdPartyViewControls);
registerViewControl('tms_vehicle', tmsVehicleControls);
registerViewControl('tms_vehicle_attendance', tmsVehicleAttendanceControls);
registerViewControl('tms_ist', tmsISTControls);
registerViewControl('tms_bag', tmsBagControls);
registerViewControl('tms_setup_route', tmsSetupRouteControls);
registerViewControl('tms_setup_connection', tmsSetupConnectionControls);
registerViewControl('tms_setup_exception', tmsSetupExceptionControls);
registerViewControl('tms_setup_bagging', tmsSetupBaggingControls);
registerViewControl('setup_booking_masters', setupBookingMastersControls);
registerViewControl('setup_courier_account_integrations', setupCarrierMastersRevamp);
registerViewControl('setup_allocation_masters', setupAllocationMasters);
registerViewControl('setup_routing', setupRoutingControls);
registerViewControl('shelf', shelfControls);
registerViewControl('crate', crateControls);
registerViewControl('logistics_express', logisticsExpressCN);
registerViewControl('manifest_declaration', ManifestDeclarationCN);
registerViewControl('consolidated_planning', consolidatedPlanningCN);
registerViewControl('tms_setup_gate', tmsSetupGateControls);
registerViewControl('tms_setup_dock', tmsSetupDockControls);
registerViewControl('tms_setup_vehicle_documents', tmsSetupVehicleDocumentsControls);
registerViewControl('rider_recon', riderReconControls);
registerViewControl('approval_requests', approvalRequestsControls);
registerViewControl('calls_overview', callsOverview);
registerViewControl('my_calls', myCalls);
registerViewControl('reasonCategoryMaster', reasonCategoryMasterControls);
registerViewControl('resequencingReasonMaster', resequencingReasonMasterControls);
registerViewControl('addAdhocCharges', addAdhocChargesControls);
registerViewControl('ltlNDRMaster', ltlNDRMasterControls);
registerViewControl('packagingTypeMaster', packagingTypeMasterControls);
registerViewControl('partialDeliveryReasons', partialDeliveryReasonControls);
registerViewControl('lateDeliveryReasons', lateDeliveryReasonControls);
registerViewControl('courierPartnerChangeReasons', CarrierChangeReasonMasterData);
registerViewControl('serviceTaskMapping', serviceTaskMappingControls);
registerViewControl('tms_setup_ewb_threshold_master', tmsEwbThresholdMasterControls);
registerViewControl('tripContracts', tripContractsMasterControls);
registerViewControl('appUserApproval', appUserApprovalControls);
registerViewControl('vehicleApproval', vehicleApprovalControls);
registerViewControl('currencyConversion', currencyConversionControls);
registerViewControl('supply_request', supplyRequestControls);
registerViewControl('addressRegister', addressRegisterControls);
registerViewControl('customerManage', customerManageControls);
registerViewControl('supplementaryServices', supplementaryServicesControls);
registerViewControl('itemUnitMaster', itemUnitMasterControls);
registerViewControl('valletTransactions', ValletTransactionsViewControls);
registerViewControl('financeUploadRequests', FinanceUploadRequestsViewControls);
registerViewControl('vehicleCompartmentMaster', vehicleCompartmentMasterControls);
registerViewControl('flmRouteMaster', flmRouteMasterControls);
registerViewControl(MAP_EDIT_VIEW_TYPE, tripMapEditControls);

/**
 * Retrieves the view control with master data filter based on the given view type.
 * If bucketToShow is not present in the master data, it returns the view control as-is.
 */
export function getViewControlWithMasterDataFilter(viewType: string, viewConfig: any = {}) {
  const viewControl = getViewControl(viewType);
  const bucketToShow = viewConfig?.[viewType]?.bucket_to_show || [];
  if (bucketToShow.length && viewControl?.buckets) {
    viewControl.buckets = viewControl.buckets.filter(bucket => bucketToShow.includes(bucket));
  }
  return viewControl;
}

export function getViewBucketsWithFilter(viewType: string, viewConfig: any = {}) {
  const buckets = getViewBuckets(viewType);
  const bucketToShow = viewConfig?.[viewType]?.bucket_to_show || [];
  if (!bucketToShow.length) {
    return buckets;
  }
  const filteredBuckets = {};
  for (const bucket of Object.keys(buckets)) {
    if (bucketToShow.includes(bucket)) {
      filteredBuckets[bucket] = buckets[bucket];
    }
  }
  return filteredBuckets;
}

export {
  getViewControl,
  getViewBuckets,
  getViewBucketColor,
  getDefaultSubBuckets,
  enhanceGeolocationFeatureBuckets,
};
